import axios from 'axios';
import { EventBus } from '../EventBus';

import { highlightRegion } from './layers';

export function j(thing) {
    return thing && JSON.parse(JSON.stringify(thing));
}

export const fitBoundsPadding = () => {
    const r = window.map.getCanvas().getClientRects()[0];
    console.log(r);
    const ratio = 0.2;
    const b = {
        top: r.height * ratio,
        left: r.width * ratio,
        right: r.width * ratio,
        bottom: r.height * ratio,

        // top: r.height > 1200 ? 250 : 60,
        // left: r.width > 800 ? 250 : 40,
        // right: r.width > 800 ? 250 : 40,
        // bottom: r.height > 1200 ? 250 : 60,
    };
    console.log('bounds', b);
    return b;
};

export function selectRegion(feature) {
    EventBus.$emit('select-feature', feature);
    highlightRegion(window.leftmap, feature ? feature.properties : null);
    window.leftmap.U.toggle(/smallscale/, !feature);
    if (!window.location.search.match(/noupdate/)) {
        loadFullAttributes(feature);
    }
}

const loadFullAttributesFromTiles = (feature) => {
    let sourceLayer = feature.sourceLayer || '';
    const useLabels = false;
    if (true || !sourceLayer) {
        if (feature.source === 'topLabels' || sourceLayer.match(/top/)) {
            // sourceLayer =
            sourceLayer = useLabels
                ? 'm_top_labels-9isyyt'
                : // : 'master_top_20_04-bxq4qz';
                  'top4326';
        }
        if (feature.source === 'midLabels' || sourceLayer.match(/mid/)) {
            // if (sourceLayer === 'middle-labels') {
            // sourceLayer =
            sourceLayer = useLabels
                ? 'Lbls_middle-764v5'
                : //'mstr_middle';
                  'mstr_middle-3ysqay';
        }
        if (
            feature.source === 'subregion-labels' ||
            sourceLayer.match(/s.*b.*r.*g.*n/)
        ) {
            // sourceLayer =
            sourceLayer = useLabels
                ? 'm_sbrgn_labels-afx25k'
                : // : 'mstr_sbrgns';
                  'subrgns4326';
        }
    }
    // mstr_sbrgns
    // mstr_middle
    // master_top_20_04-bxq4qz
    // debugger;
    const f = window.leftmap.querySourceFeatures('composite', {
        sourceLayer,
        filter: ['==', ['get', 'Name_rgn'], feature.properties.Name_rgn],
    });
    // console.log(`Attributes from vector tiles ${sourceLayer}`, j(f[0]));
    if (f.length) EventBus.$emit('select-feature', f[0]);
};

// the most up to date data is in the vector tiles
function loadFullAttributes(feature) {
    if (!feature) {
        console.log('loadFullAttributes no feature');
        return;
    }
    // debugger;
    // console.log('full load', j(feature));
    loadFullAttributesFromTiles(feature);
    // we want to make sure we don't show the data if the user has closed the feature window
    let attributeLoadCount = (window.attributeLoadCount || 0) + 1;
    window.attributeLoadCount = attributeLoadCount;
    window.leftmap.once('idle', () => {
        if (window.attributeLoadCount === attributeLoadCount) {
            loadFullAttributesFromTiles(feature);
        }
    });
}

let regionIndex;
let regionIndexPromise;

export function getRegionIndex() {
    return regionIndex || [];
}

export async function loadIndex() {
    regionIndexPromise =
        regionIndexPromise ||
        Promise.all([
            axios.get('top-labels.geojson'),
            axios.get('mid-labels.geojson'),
            axios.get('subregion-labels.geojson'),
        ]);
    // await regionIndexPromise;

    if (regionIndex) return regionIndex;
    const r = await regionIndexPromise;

    const [
        { data: topLabels },
        { data: midLabels },
        { data: subregionLabels },
    ] = r;

    regionIndex = [
        ...topLabels.features.map((f) => ({
            ...f,
            source: 'topLabels',
        })),
        ...midLabels.features.map((f) => ({
            ...f,
            source: 'midLabels',
        })),
        ...subregionLabels.features.map((f) => ({
            ...f,
            source: 'subregionLabels',
        })),
    ];
    return regionIndex;
}
